// 图片末尾加时间戳，解决浏览器缓存图片不更新问题
const imgSrcTimestamp = (src) => {
  return src + '?time=' + Date.now()
}

const formatDate = (gmtDateString) => {
  let gmtDate = new Date(gmtDateString)
  gmtDate = new Date(gmtDate.getTime() + (8 * 60 * 60 * 1000)) // 增加8小时的时间差
  const year = gmtDate.getUTCFullYear()
  const month = String(gmtDate.getUTCMonth() + 1).padStart(2, '0')
  const day = String(gmtDate.getUTCDate()).padStart(2, '0')
  const hours = String(gmtDate.getUTCHours()).padStart(2, '0')
  const minutes = String(gmtDate.getUTCMinutes()).padStart(2, '0')
  const seconds = String(gmtDate.getUTCSeconds()).padStart(2, '0')
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}
/**
 * 对象转键值对
 * @param {*} obj
 */
const serialize = (obj) => {
  var str = []
  for (var key in obj) {
    if (key) {
      str.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
    }
  }
  // console.log(str.join('&'))
  return str.join('&')
}
export {
  imgSrcTimestamp,
  formatDate,
  serialize
}
